import { useParams } from "react-router-dom";
import Kanban from "@/components/shared/Kanban";
import api from "@/lib/api";

const STAGES = ["Nouveau", "Contacté", "Intéressé", "Relance", "Client", "Perdu"];

export default function StoreCRM() {
  const { slug } = useParams();
  return (
    <Kanban
      title="CRM"
      subtitle="Suivez vos prospects et convertissez-les en clients"
      stages={STAGES}
      testid="store-crm"
      fetchList={() => api.get(`/store/${slug}/prospects`).then((r) => r.data)}
      createItem={(body) => api.post(`/store/${slug}/prospects`, body)}
      moveStage={(id, stage) => api.patch(`/store/${slug}/prospects/${id}/stage`, { stage })}
    />
  );
}
